import React from 'react'
import '../assets/style/Normalize.css'
import '../assets/style/CarsHeader.css'

const CarsHeader = () => {
  return (
  <>
  <header className="cars-header"> </header>
  </>
  )
}

export default CarsHeader